import { StyleSheet } from 'react-native';

const styles = StyleSheet.create({
  container: {
    alignItems: "center",
    justifyContent: "center",
    paddingHorizontal: 25,
    marginTop: 20
  },
  contentBtns: {
    flexDirection: 'row',
    justifyContent: 'center',
    padding: 25
  },
  btn: {
    backgroundColor: '#32BFB1',
    paddingVertical: 10,
    paddingHorizontal: 20,
    marginRight: 25,
    borderRadius: 4
  },
  descriptionPerfil: {
    marginTop: 7,
    width: '100%',
    fontSize: 20,
    textAlign: 'center',
  },
  perfil: {
    fontWeight: 'bold',
    marginTop: 40,
    fontSize: 40,
    textAlign: 'center',
    color: 'green'
  },
  containerPerfil: {
    flex: 0.5,
    paddingHorizontal: 25,
    justifyContent: 'center'
  },
  textBtn: {
    textAlign: 'center',
    color: '#fff'
  },
  description: {
    marginTop: 7,
    width: '90%'
  },
  contentRadioButton: {
    flexDirection: 'row'
  },
  titleStep: {
    fontWeight: 'bold',
    fontSize: 15,
    marginBottom: 25
  }
});

export default styles;
